export const decodeHtml = (html?: string): string | undefined => {
    if (typeof html !== 'string') {
        return undefined;
    }
    const txt = document.createElement('textarea');
    txt.innerHTML = html;
    return txt.value;
};
